export const messages={
    tableHeader1:"Project",
    tableHeader2:"Use",
    title:"Manage Permissions"
}